function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CerbosOrgActions, CerbosOrgKind } from '@repo/cerbos-types';
import { buildAbacPrincipal, buildOrganizationAttributes } from '../abac';
import { getDecision } from '../decision';
const checkAction = async (organization, user, action)=>{
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosOrgKind,
            id: organization.id,
            attributes: _object_spread_props(_object_spread({}, buildOrganizationAttributes(organization)), {
                oldData: {},
                newData: {},
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
const checkActions = async (organization, user, actions)=>{
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosOrgKind,
            id: organization.id,
            attributes: _object_spread_props(_object_spread({}, buildOrganizationAttributes(organization)), {
                oldData: {},
                newData: {},
                organization: organization
            })
        },
        actions
    });
    return actions.map((action)=>decision.isAllowed(action));
};
export const canMangeConfigKey = [
    'canManageOrg',
    CerbosOrgActions.UPDATE_ORGANIZATION,
    CerbosOrgActions.UPDATE_ORGANIZATION_NAME,
    CerbosOrgActions.UPDATE_ORGANIZATION_SETTINGS,
    CerbosOrgActions.DELETE_ORGANIZATION,
    CerbosOrgActions.CREATE_PROJECT
].join('/');
export const getCanManageOrgConfig = async (organization, user)=>{
    const [updateOrganization, updateOrganizationName, updateOrganizationSettings, deleteOrganization, createProject] = await checkActions(organization, user, [
        CerbosOrgActions.UPDATE_ORGANIZATION,
        CerbosOrgActions.UPDATE_ORGANIZATION_NAME,
        CerbosOrgActions.UPDATE_ORGANIZATION_SETTINGS,
        CerbosOrgActions.DELETE_ORGANIZATION,
        CerbosOrgActions.CREATE_PROJECT
    ]);
    return {
        updateOrganization: updateOrganization !== null && updateOrganization !== void 0 ? updateOrganization : false,
        updateOrganizationName: updateOrganizationName !== null && updateOrganizationName !== void 0 ? updateOrganizationName : false,
        updateOrganizationSettings: updateOrganizationSettings !== null && updateOrganizationSettings !== void 0 ? updateOrganizationSettings : false,
        deleteOrganization: deleteOrganization !== null && deleteOrganization !== void 0 ? deleteOrganization : false,
        createProject: createProject !== null && createProject !== void 0 ? createProject : false
    };
};
export const getCanManageIntegrations = async (organization, user)=>{
    return checkAction(organization, user, CerbosOrgActions.UPDATE_ORG_DEPLOYMENT_INTEGRATIONS);
};
export const canMangeIntegrationsKey = [
    'canManage',
    CerbosOrgActions.UPDATE_ORG_DEPLOYMENT_INTEGRATIONS
].join('/');
